import { path } from "ramda";
import Moment from "moment";
import i18n from "../i18n/index";
import { DateUtil, ArrayUtil, OrgUtil } from "./";
import { CounselingSupportGraph, StressTestSupportGraph, BaseSupportGraph } from "../constants/supportGraph";
import { GraphDataMaker } from "./helper/graph";

//region Filter to breadcrumb converter
export const defaultFilterToBread = (typeKey,value)=>{
	const key = i18n.t(typeKey);
	const catNames = OrgUtil.getAllCategoryName().map(n=>n.toLowerCase());
	if(catNames.indexOf(typeKey.toLowerCase()) !== -1){
		const key = typeKey.charAt(0).toUpperCase() + typeKey.substring(1);
		let name = undefined;
		if(typeof value === "object"){
			name = OrgUtil.getCategoryItemNameByID(key, value.id);
		}else if(typeof value ==="number"){
			name = OrgUtil.getCategoryItemNameByID(key, value);
		}
		if(name === undefined){
			name = i18n.t("unassign");
		}
		return {key:typeKey, value:name};
	}
	switch(typeKey){
	case BaseSupportGraph.Returning:
		let time = value;
		if(typeof value === "number"){
			time = GraphDataMaker.getReturningTimeLabel(value);
		}
		return {key, value:time};
	case BaseSupportGraph.AgeRange:
		if(typeof value === "object"){
			return {key, value: value.join("-")};
		}
		return {key, value};
	default:
		if(typeof value === "string"){
			const valLower = value.toLowerCase();
			let vName = i18n.t(valLower);
			if(vName === valLower){
				vName = vName.charAt(0).toUpperCase() + vName.substring(1);
			}
			return {key:i18n.t(typeKey), value:vName};
		}
		return {key:i18n.t(typeKey), value};
	}
};
export const counselingFilterToBread = (typeKey, value)=>{
	const key = i18n.t(typeKey);
	let out = {};
	switch(typeKey){
	case CounselingSupportGraph.Returning:
		if(typeof value === "number"){
			out = {key, value: GraphDataMaker.getReturningTimeLabel(value)};
		}else if(typeof value === "object"){
			out = {key, value: value.title};
		}else{
			out = {key, value};
		}
		break;
	case CounselingSupportGraph.Tag:
		out = {key, value: value.title};
		break;
	case CounselingSupportGraph.Feedback:
		out = {key:i18n.t(value.type), value:i18n.t(value.value)};
		break;
	case CounselingSupportGraph.Platform:
		out = {key, value:i18n.t(`call_channels.${value.toLowerCase()}`)};
		break;
	default:
		out = defaultFilterToBread(typeKey, value);
		break;
	}
	return out;
};
export const stressFilterToBread = (typeKey, value)=>{
	const key = i18n.t(typeKey);
	switch(typeKey){
	case StressTestSupportGraph.StressLevel:
		return {key, value: value.item};
	default:
		return defaultFilterToBread(typeKey, value);
	}
};
//endregion

//region Filter to request filter converter
export const defaultFilterToRequest = (typeKey, value)=>{
	const catNames = OrgUtil.getAllCategoryName().map(n=>n.toLowerCase());
	if(catNames.indexOf(typeKey.toLowerCase()) !== -1){
		let mutateValue = value;
		switch(typeof value){
		case "object":
			mutateValue = value.id;
			break;
		case "string":
			mutateValue = OrgUtil.getCategoryIdByName(typeKey, value);
			break;
		}
		return {
			key:typeKey,
			value:mutateValue
		};
	}
	switch(typeKey){
	case BaseSupportGraph.Returning:
		if(typeof value === "number"){
			return {key:typeKey, value};
		}
		const time = parseInt(value.split(" ")[0]);
		return {key:typeKey, value:time};
	case BaseSupportGraph.AgeRange:
		if(typeof value === "string"){
			return {key:typeKey, value:value.split("-").map(v=>parseInt(v))};
		}
		return {key:typeKey, value};
	default:
		
		return {
			key:typeKey, 
			value: typeof value === "string" ? 
				value.toLowerCase() : value
		};
	}
};
export const counselingFilterToRequest = (typeKey, value)=>{
	switch(typeKey){
	case CounselingSupportGraph.Returning:
		if(typeof value === "object"){
			return {
				key: typeKey,
				value:parseInt(value.title.split(" ")[0])
			};
		}else if(typeof value === "string"){
			return {
				key: typeKey,
				value:parseInt(value.split(" ")[0])
			};
		}
		return {
			key: typeKey,
			value
		};
	case CounselingSupportGraph.Tag:
		return { key:"topic_id", value: value.id};
	case CounselingSupportGraph.Feedback:
		return {key:value.type, value:value.value};
	default:
		return defaultFilterToRequest(typeKey, value);
	}
};
export const stressFilterToRequest = (typeKey, value)=>{
	switch(typeKey){
	case StressTestSupportGraph.StressLevel:
		return {
			key: typeKey,
			value: value.level,
		};
	default:
		return defaultFilterToRequest(typeKey, value);
	}
};
//endregion

export default {
	toMomentCompareDate(reportDate){
		const outs = { ...reportDate };
		Object.keys(outs).forEach(key=>{
			if(ArrayUtil.isAliveArray(outs[key])){
				outs[key] = outs[key].map(mo=>Moment(mo,"X"));
			}
		});
		return outs;
	},
	createSaveCompareDate(momentDateRages){
		const outs = { ...momentDateRages };
		Object.keys(momentDateRages).forEach(key=>{
			outs[key] = this.toSaveCompareDate(outs[key]);
		});
		return outs;
	},
	toSaveCompareDate(date){
		return ArrayUtil.isAliveArray(date) ? date.map(mo=>{
			if(typeof mo === "string"){
				return mo;
			}
			return mo.format("X");
		}) : date;
	},
	pickAvailableNumberValueKey(itemObject){
		const keys = Object.keys(itemObject);
		const index = Math.max(0, keys.findIndex(k=>itemObject[k]>0));
		return keys[index];
	}
};


// WEBPACK FOOTER //
// ./src/util/report.js